import { ReactNode } from 'react';
import { useRebrandingStore } from 'components/FeatureFlagsProvider/store/useRebrandingStore';
import { ThemeSwitchProvider, useStorage, useThemeSelector } from '@redislabsdev/redis-ui-styles';
import { ThemeProvider } from 'styled-components/macro';
import { ThemeMain } from '../../types/theme.types';
import { ThemeSwitchProviderProps } from './ThemesProvider.types';
import { theme as themeLight } from '../../themeLight/theme';
import { theme as themeDark } from '../../themeDark/theme';
import { theme as themeLight2 } from '../../themeLight2/theme';
import { theme as themeDark2 } from '../../themeDark2/theme';
import { ThemeChangeHandler } from './ThemeChangeHandler';

const THEME_STORAGE_KEY = 'theme';

const LightThemeType = 'light';
const DarkThemeType = 'dark';
const AllThemes = {
  lightThemeName: LightThemeType,
  darkThemeName: DarkThemeType
} as const;

interface SwitchableThemeProviderProps {
  children: ReactNode;
  lightTheme: ThemeMain;
  darkTheme: ThemeMain;
  storageKey: string;
}

// todo: make refactoring in redis-ui and use this provider from there
export const SwitchableThemeProvider = ({
  children,
  lightTheme,
  darkTheme,
  storageKey
}: SwitchableThemeProviderProps) => {
  const { selectedTheme, setSelectedTheme, currentTheme } = useThemeSelector(AllThemes);
  useStorage({ storageKey, value: selectedTheme, onChange: setSelectedTheme });

  return (
    <ThemeProvider theme={currentTheme === DarkThemeType ? darkTheme : lightTheme}>
      <ThemeSwitchProvider {...{ selectedTheme, setSelectedTheme }} {...AllThemes}>
        {children}
      </ThemeSwitchProvider>
    </ThemeProvider>
  );
};

const ThemesProvider = ({ children }: ThemeSwitchProviderProps) => {
  const enableRebranding = useRebrandingStore((state) => state.enableRebranding);

  return (
    <SwitchableThemeProvider
      lightTheme={enableRebranding ? themeLight2 : themeLight}
      darkTheme={enableRebranding ? themeDark2 : themeDark}
      storageKey={THEME_STORAGE_KEY}
    >
      <ThemeChangeHandler />
      {children}
    </SwitchableThemeProvider>
  );
};

export default ThemesProvider;
